/**
 * Scrolls the Starter Pack card so its price row stays readable above the fixed tutorial panel: the panel spans the
 * phone width and covers the lower part of the viewport, so centring the card hides its price behind it.
 */
export function scrollCardAbovePanel(card: HTMLElement, panel: HTMLElement | null, behavior: ScrollBehavior) {
  const container = scrollParent(card);
  const containerBottom = container ? container.getBoundingClientRect().bottom : window.innerHeight;
  const overlap = panel ? Math.max(0, containerBottom - panel.getBoundingClientRect().top) : 0;
  card.style.scrollMarginTop = "12px";
  card.style.scrollMarginBottom = `${overlap + 12}px`;
  card.scrollIntoView({ block: overlap > 0 ? "end" : "center", behavior });
}

function scrollParent(element: HTMLElement): HTMLElement | null {
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    const { overflowY } = getComputedStyle(parent);
    if ((overflowY === "auto" || overflowY === "scroll") && parent.scrollHeight > parent.clientHeight) return parent;
  }
  return null;
}
